import { Component, HostListener, OnInit } from '@angular/core';
import { Notice } from './notice';
import { InfoService } from '../info.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

/**
 * This class represents the navigation bar component.
 */
@Component({
    selector: 'cloud-app-info',
    templateUrl: 'notice.component.html',
    styleUrls: ['notice.component.scss'],
    animations: [
        trigger('noticeState', [
            state('fadeIn', style({ display: 'block', opacity: 1 })),
            state('fadeOut', style({ visibility: 'hidden', opacity: 0 })),
            state('slideDown', style({ display: 'none', height: 0 })),
            transition('fadeIn => fadeOut', animate('150ms ease-in')),
            transition('fadeOut => fadeIn', animate('150ms ease-out')),
            transition('fadeOut => slideDown', animate('150ms ease-out'))
        ])
    ]
})
export class NoticeComponent implements OnInit {
    public notices: Notice[] = [];

    private _timeout = 20000;
    private _animationTimeout = 150;
    private _noticeId = -1;

    constructor(public info: InfoService) {
    }

    @HostListener('document:keyup', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        const x = event.key;
        if (x === 'Escape') {
            this.dismissAll();
        }
    }

    ngOnInit() {
        this.info.notice$.subscribe((res) => {
            if (res.message) {
                this._noticeId++;
                res.id = this._noticeId;
                this.notices[this._noticeId] = res;
                this.notices[this._noticeId].styles = { top: this.activeNotices * 4 + 'em' };

                setTimeout(() => {
                    if (this.notices && this.notices[this._noticeId]) {
                        this.notices[this._noticeId].state = 'fadeIn';
                    }
                }, 20);

                if (this._timeout) {
                    setTimeout(() => {
                        if (this.notices[res.id]) {
                            this.dismiss(res.id);
                        }
                    }, this._timeout);
                }
            } else {
                this.dismissAll();
            }
        });

        this.info.endWait$.subscribe((res) => {
            this.dismissAll();
        });
    }

    public dismiss(id: number): void {
        if (this.notices && this.notices[id]) {
            this.notices[id].state = 'fadeOut';
            setTimeout(() => {
                delete this.notices[id];
            }, this._animationTimeout);
        }
    }

    public dismissAll() {
        for (const n of this.notices) {
            if (n != null) {
                this.notices[n.id] = null;
            }
        }
    }

    get activeNotices(): number {
        let cnt = 0;
        for (const n of this.notices) {
            if (n) {
                cnt++;
            }
        }
        return cnt;
    }
}
